import React, { useState } from "react";
import { Modal } from "../Modal";
export function useModal(options) {
    const [modalVisible, setModalVisible] = useState(!!options?.defaultVisible);
    const ModalComponent = ({ children, ...props }) => {
        if (!modalVisible)
            return React.createElement(React.Fragment, null);
        return React.createElement(Modal, { ...props }, children);
    };
    return [ModalComponent, setModalVisible, modalVisible];
}
//# sourceMappingURL=useModal.js.map